@if (summaryMessage != null && (isRewardTokenSelectorVisible$ | async)) {
    @if (accaBoostConfig.isEnhancedLayoutEnabled && tokenType === RewardTokenType.AccaBoost) {
        <ms-acca-boost-logo [accaBoostRewardTitle]="summaryMessage" [showInfoIcon]="true" (clickInfoEvent)="displayInfo()" />
    } @else {
        <div
            class="betslip-summary__token-payout-summary"
            [ngClass]="{
                'betslip-summary__token-payout-summary--odds-boost': tokenType === RewardTokenType.OddsBoost,
                'betslip-summary__token-payout-summary--acca-boost theme-acca-boost': tokenType === RewardTokenType.AccaBoost,
            }"
            [innerHTML]="summaryMessage"></div>
    }
}
